import {Box} from "@mui/material";
import {sx} from './sx'
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import ErrorBlock from "@ui/errors/errorBlock/ErrorBlock";
import {FC, ReactNode} from "react";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    children: ReactNode,
    isLoading?: boolean,
    isLoadingWithoutRender?: boolean,
    isError?: boolean,
    onRefresh?: () => void,
    sx?: SxType,
    errorMessage?:string,
    onResetError?:()=>void,
    resetErrorButtonMessage?:string,
    className?:string,
}

const ActionUiHandler: FC<IProps> = ({
                                         children,
                                         isLoading,
                                         isLoadingWithoutRender,
                                         isError,
                                         onRefresh,
                                         errorMessage,
                                         onResetError,
                                         resetErrorButtonMessage,
                                         sx: sxProps = {},
                                         className
                                     }) => {


    if (isLoadingWithoutRender) {
        return <SpinnerCustom variant={'absolute'}/>
    }

    return (
        <Box
            sx={{
                opacity: isLoading ? '.5' : '1',
                pointerEvents: isLoading ? 'none' : 'inherit',
                ...sx.root,
                ...sxProps
            }}
            className={className}
        >
            {isLoading && <SpinnerCustom variant={'absolute'}/>}
            {isError && <ErrorBlock
                message={errorMessage}
                onRefresh={onRefresh}
                onResetError={onResetError}
                resetErrorButtonMessage={resetErrorButtonMessage}
                variant={'overlay'}
            />}

            {children}
        </Box>
    );
};

export default ActionUiHandler
